export default __webpack_public_path__ + "images/6K.27b6cba.png";